import { LoadingRegion } from "@commerce/components/page";
import { PlatformScreen } from "@commerce/platform/PlatformScreen";
import { config } from "@repo/config";
import { AsyncBoundary } from "@shared/components/AsyncBoundary";
import { orpc } from "@shared/lib/orpc";
import { dehydrateForLoader, getServerQueryClient } from "@shared/lib/server";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_saas/app/_account/platform")({
	beforeLoad: ({ context }) => {
		if (context.session.user.role !== "admin") {
			throw redirect({ to: "/app" });
		}
	},
	loader: async () => {
		const queryClient = getServerQueryClient();
		await Promise.all([
			queryClient.ensureQueryData(
				orpc.platform.retailers.list.queryOptions({ input: {} }),
			),
			queryClient.ensureQueryData(
				orpc.platform.visitors.list.queryOptions({
					input: { days: 14 },
				}),
			),
			queryClient.ensureQueryData(
				orpc.platform.partners.list.queryOptions(),
			),
			queryClient.ensureQueryData(orpc.platform.usage.queryOptions()),
		]);
		return { dehydratedState: dehydrateForLoader(queryClient) };
	},
	head: () => ({ meta: [{ title: `Platform - ${config.appName}` }] }),
	component: PlatformPage,
});

function PlatformPage() {
	const { dehydratedState } = Route.useLoaderData();
	return (
		<AsyncBoundary
			fallback={<LoadingRegion label="Loading retailers" />}
			dehydratedState={dehydratedState}
		>
			<PlatformScreen />
		</AsyncBoundary>
	);
}
